<template>
  <div id="app" class="app">
    <PulseLoader
      :loading="isLoadingFromRealmPage || isBetweenPages"
      class="spinner-overview"
      color="#1d234f"
    />
    <router-view v-slot="{ Component }">
      <keep-alive include="home">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
  name: 'App',
  components: {
    PulseLoader
  },
  data() {
    return {
      isBetweenPages: true,
      isLoadingFromRealmPage: false
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(newRoute, oldRoute) {
        // Handle loading spinner for Zynka users after realm selection (isLoadingFromRealmPage)
        if (oldRoute?.name === 'realm') {
          this.isLoadingFromRealmPage = true
        }
        // Need to track oidcCallback instead of home, since home is loaded twice for for Zynka users
        if (!oldRoute || oldRoute?.name === 'oidcCallback' || newRoute?.name === 'realm') {
          this.isLoadingFromRealmPage = false
        }

        // Handle loading spinner for routes without content to display (isBetweenPages)
        if (!newRoute) {
          this.isBetweenPages = true
        }
        if (
          newRoute?.path.startsWith('/home') ||
          newRoute?.path === '/info' ||
          newRoute?.name === 'instance' ||
          newRoute?.path === '/pageNotFound' ||
          newRoute?.path === '/realm'
        ) {
          this.isBetweenPages = false
        } else {
          this.isBetweenPages = true
        }
      }
    }
  },
  mounted() {
    this.addCtrlScrollListener()
  },
  methods: {
    // Prevents ctrlScroll on other elements than the map/viewer (mainly due to touch pad issues)
    addCtrlScrollListener() {
      window.addEventListener(
        'wheel',
        (e) => {
          if (e.ctrlKey) e.preventDefault()
        },
        { passive: false }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
@use '@/styles/variables.scss';
.spinner-overview {
  align-items: center;
  background: variables.$color-grey-light; // Should match background in index.html
  display: flex;
  height: 100vh;
  justify-content: center;
  margin: auto;
  position: absolute;
  width: 100vw;
  z-index: 10000;
}
</style>
